$("document").ready(function () {
    var bodyH = $(document).outerHeight();
    var contentHeight = bodyH - 150;
    var overlay = $('.overlay_bg');
    
    $(".main_category_list")
        .mouseenter(function () {
            overlay.addClass('activate');
            overlay.height(contentHeight);
        })
        .mouseleave(function () {
            overlay.removeClass('activate');
            overlay.css("height", "unset");

        });


    
});

